/* eslint-disable*/
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";

const getSelectedBGColor  = {
    'bg-yellow-100': 'bg-yellow-100',
    'bg-yellow-200': 'bg-yellow-200',
    'bg-yellow-300': 'bg-yellow-300',
    'bg-yellow-400': 'bg-yellow-400',
    'bg-yellow-500': 'bg-yellow-500',
};

const Tab = (props) => {
    const {tabValue, handleTabChange, tabList, activeTabColor= 'bg-yellow-500'} = props;
    return (
    <Tabs
    value={tabValue}
    onValueChange={(value) => handleTabChange(value)}
    defaultValue={tabValue}
    className='p-2 pb-0'
>
    <TabsList className='h-auto w-auto inline-flex'>
        {tabList.map((tab) => ( 
        <TabsTrigger
            value={tab.value}
             className={`px-4 data-[state=active]:h-[2.5rem] data-[state=active]:${getSelectedBGColor[activeTabColor]} data-[state=active]:text-black data-[state=active]:m-1 data-[state=active]:rounded-md`}
        >
            {tab.label}
        </TabsTrigger>
        ))}
        </TabsList>
    </Tabs>
    );
};

export default Tab;
